import {getCities, getDataset} from './dataset';
import Vue from 'vue';
import {setCity} from './api.js'

export const CityChooser = {
    methods: {
        async initAutocomplete() {
            const setURL = this.$el.dataset.apiSet;
            const callbackName = this.$el.dataset.callback;
            /** @type {function} */
            const callback = window[callbackName];
            const dataset = getDataset();

            dataset.source = (query, cb) => getCities(query).then(cb);

            const {default: autocomplete} = await import('autocomplete.js');

            this.$options.autocomplete = autocomplete(this.$el, {
                cssClasses: {
                    noPrefix: true,
                    dropdownMenu: 'city-chooser__dropdown',
                    input: 'city-chooser__input',
                    suggestions: 'city-chooser__suggestions',
                    suggestion: 'city-chooser__suggestion',
                    cursor: 'is-selected',
                    empty: 'city-chooser__suggestions',
                },
                templates: {
                    empty: () => 'По запросу ничего не найдено',
                },
            }, [dataset]);

            this.$options.autocomplete.on('autocomplete:selected', (event, suggestion) => setCity(setURL, suggestion, callback));

            this.$el.addEventListener('focus', (event) => {
                const savedValue = event.currentTarget.value;

                this.$el.addEventListener('blur', (event) => {
                    event.currentTarget.value = savedValue;
                }, {once: true});
            });
        },
    },
    mounted() {
        this.initAutocomplete();
    },
    destroyed() {
        if (this.$options.autocomplete)
            this.$options.autocomplete.destroy();
    },
    render(h) {
        return (
            <input/>
        );
    }
}

export function registerComponent() {
    const isRegistered = Vue.component('city-chooser');

    if (!isRegistered)
        Vue.component('city-chooser', CityChooser);
}
